import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./BlogSkeleton.css";

export const BlogCardSkeleton = () => {
  return (
    <div className="item-card skeleton-card">
      <div className="meta">
        <Skeleton width={80} height={14} />
        <Skeleton width={70} height={14} />
      </div>
      <Skeleton height={24} style={{ marginBottom: "12px" }} />
      <Skeleton count={3} height={16} style={{ marginBottom: "12px" }} />
      <Skeleton height={200} style={{ marginTop: "12px", borderRadius: "8px" }} />
      <div className="card-arrow-skeleton">
        <Skeleton width={24} height={24} circle />
      </div>
    </div>
  );
};

export const TrendingBannerSkeleton = () => {
  return (
    <div className="story-1 skeleton-banner">
      <Skeleton height={222} style={{ borderRadius: "0" }} />
      <span>
        <div>
          <Skeleton width={150} height={20} />
        </div>
        <Skeleton width="80%" height={20} style={{ marginTop: "8px" }} />
      </span>
    </div>
  );
};

export const BlogDetailSkeleton = () => {
  return (
    <div className="blog-detail-skeleton">
      <Skeleton height={40} width={150} style={{ marginBottom: "24px" }} />
      <Skeleton height={48} style={{ marginBottom: "16px" }} />
      <Skeleton height={20} width={200} style={{ marginBottom: "24px" }} />
      <Skeleton height={400} style={{ marginBottom: "24px", borderRadius: "8px" }} />
      <Skeleton count={8} height={18} style={{ marginBottom: "8px" }} />
    </div>
  );
};

export const CommentSkeleton = () => {
  return (
    <div className="comment-skeleton">
      <div className="comment-header-skeleton">
        <Skeleton width={120} height={18} />
        <Skeleton width={100} height={14} />
      </div>
      <Skeleton count={2} height={16} style={{ marginTop: "8px" }} />
    </div>
  );
};

export const RelatedBlogSkeleton = () => {
  return (
    <div className="related-blog-skeleton">
      <Skeleton height={120} style={{ borderRadius: "8px", marginBottom: "12px" }} />
      <Skeleton height={18} style={{ marginBottom: "8px" }} />
      <Skeleton height={14} width="60%" />
    </div>
  );
};

